import { error, money } from 'services/graphql/fragments/Fragments';
import { gql } from 'urql';

const fees = `
  minFee {
    ...money
  }
  maxFee {
    ...money
  }
`;
const queryVaroAdvanceEligibility = gql`
  query VaroAdvanceEligibility {
    varoAdvanceEligibility {
      __typename
      ... on VaroAdvanceEligibilityQualified {
        maxAmount {
          ...money
        }
        ${fees}
        title
        qualificationContent
        isFirstTime
      }
      ... on VaroAdvanceEligibilityNotQualified {
        ${fees}
        maxAmount {
          ...money
        }
        title       
        qualificationContentList
      }
      ... on VaroAdvanceEligibilityError {
        ...error
      }
    }
  }
  ${money}
  ${error}
`;
export default queryVaroAdvanceEligibility;
